import httpInstance from '../httpInstance';

const getProvidersService = async () => {
  let res;
  const endpoint = '/service-payment/v1/beneficiaries/recharge-services';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getProvidersService;
